import dataService from "../../../services/data.service";

/**
 * @param {object|null|undefined} comparison
 * @returns {boolean}
 */
export function hasConfiguredPlanComparison(comparison) {
  if (!comparison?.dataType) return false;

  if (comparison.dataType === "Snapshot") {
    const date = comparison.snapShotDate ?? comparison.snapshotDate;
    return date != null && String(date).trim() !== "";
  }

  return !!(comparison.compareToPropertyId || comparison.propertyId);
}

/**
 * @param {object|null|undefined} comparison
 * @param {object|null|undefined} planContext Plan being viewed ({ propertyIds?, fiscalYear? })
 * @returns {string|null}
 */
export function formatPlanComparisonLabel(comparison, planContext) {
  if (!hasConfiguredPlanComparison(comparison)) return null;

  const dataType = comparison.dataType || "N/A";
  const planType = comparison.planType || "N/A";
  const versionName = comparison.versionName || "N/A";
  const snapShotDate =
    comparison.snapShotDate ?? comparison.snapshotDate ?? "N/A";

  const propertyId =
    comparison.compareToPropertyId ||
    comparison.propertyId ||
    planContext?.propertyIds?.[0];
  const property = propertyId ? dataService.getPropertyById(propertyId) : null;
  const hmg = property ? property.name : "N/A";
  const year =
    comparison.year ??
    comparison.fiscalYear ??
    planContext?.fiscalYear ??
    "N/A";

  if (dataType === "Snapshot") {
    return `${hmg} | ${year} | ${planType} | Snapshot as-of ${snapShotDate}`;
  }
  if (dataType === "Actuals") {
    return `${hmg} | ${year} | ${dataType}`;
  }
  return `${hmg} | ${year} | ${planType} | ${versionName}`;
}
